import React, { useState, useEffect, useCallback } from 'react';
import ContentWrapper from '../../Layout/ContentWrapper';
import { withTranslation, Trans } from 'react-i18next';
import * as adminService from '../Services/adminService';
import * as userService from '../Services/userService';
import moment from 'moment/min/moment-with-locales';
import UsersTable from '../Components/Tables/usersTable';
import UserModal from '../Components/Modals/userModal';
import { basicDateFormat } from '../Helpers/dateTimeHelper';
import { Col, Row } from 'reactstrap';
import { ModalMode } from '../Helpers/enums';

const TenantDetails = ({ match }) => {
  const [tenant, setTenant] = useState({
    users: [{}],
    company: {},
  });
  const [showModal, setShowModal] = useState(false);
  const [modalPurpose, setModalPurpose] = useState('');
  const [userToViewOrEdit, setUserToViewOrEdit] = useState({
    roles: [],
  });

  const refreshData = useCallback(async () => {
    const tenantId = match.params.id;
    const { data } = await adminService.getTenantDetails(tenantId);
    setTenant(data);
  }, [match.params.id]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const toggle = (editOrViewOrCreate, item) => {
    switch (editOrViewOrCreate) {
      case 'create':
        setUserToViewOrEdit({ userRoles: [] });
        setModalPurpose(ModalMode.Create);
        break;
      case 'edit':
        setUserToViewOrEdit(item);
        setModalPurpose(ModalMode.Edit);
        break;
      case 'view':
        setUserToViewOrEdit(item);
        setModalPurpose(ModalMode.View);
        break;
      default:
        break;
    }
    setShowModal((prevShowModal) => !prevShowModal);
  };

  const handleValidUserSubmit = async (event, values) => {
    if (values.id === '') {
      await userService.createUser(values);
    } else {
      await userService.updateUserFromList(values);
    }
    refreshData();
    toggle('close', null);
  };

  const { company } = tenant;
  const companyAddress = company?.addresses ? company.addresses[0] : null;

  return (
    <ContentWrapper>
      <div className="content-heading">
        {/* TODO: use bootstrap css to make the content of the row visually nicer */}
        <Row>
          <Col>
            Tenant Details
            <small>Here you can manage all the details about the tenant!</small>
            <br />
          </Col>
        </Row>
      </div>
      {company ? (
        <div>
          {/* TODO: use bootstrap css to make the content of the row visually nicer */}
          <Row>
            <Col>
              <h1>Company name: {company.name}</h1>
              <div>Id: {company.id}</div>
              <div>Website: {company.website}</div>
              <div>Company type: {company.companyType}</div>
              <div>
                <b>Created:</b> {moment.utc(tenant.created).format(basicDateFormat)}
              </div>
              <div>
                <b>Modified:</b> {moment.utc(tenant.modified).local().fromNow()}
              </div>
              <br />
              <div>
                <b>Num users:</b> {tenant.numUsers}, <b>Num Jobs:</b> {tenant.numJobs}, <b>Num Applicants:</b>{' '}
                {tenant.numApplicants}
              </div>
              <br />
            </Col>
            <Col>
              <h3>
                <b>Address:</b>
              </h3>
              <div>Country Code: {companyAddress?.countryCode}</div>
              <div>Street: {companyAddress?.street}</div>
              <div>Lat for street search: {companyAddress?.latForStreetSearch}</div>
              <div>Lng for street search: {companyAddress?.lngForStreetSearch}</div>
              <div>Lat: {companyAddress?.lat}</div>
              <div>Lng: {companyAddress?.lng}</div>
              {/* <div>GooglePlaceId: {companyAddress?.googlePlaceId}</div> */}
            </Col>
          </Row>
        </div>
      ) : (
        <div className="content-heading">
          <Row>
            <Col>
              <p style={{ color: 'orange' }}> WARNING: Company has not been created yet for this user!</p>
            </Col>
          </Row>
        </div>
      )}
      <div>
        <Row>
          <Col>
            <div className="content-heading">
              <div>
                Users
                <small>Below is the list of the users belonging to the selected Tenant</small>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <UsersTable
              users={tenant.users}
              onItemClicked={(purpose, user) => toggle(purpose, user)}
              onStatusRefresh={() => refreshData()}
              hasEditingRole={true}
            />
            <UserModal
              showModal={showModal}
              userToViewOrEdit={userToViewOrEdit}
              modalPurpose={modalPurpose}
              closeModal={() => toggle('close', null)}
              onHandleValidUserSubmit={handleValidUserSubmit}
            />
          </Col>
        </Row>
      </div>
    </ContentWrapper>
  );
};

export default withTranslation('translations')(TenantDetails);
